const COUNTRY_TO_LANG = {
  IT: "it", SM: "it", VA: "it",
  ES: "es", MX: "es", AR: "es", CO: "es", CL: "es", PE: "es", VE: "es",
  EC: "es", GT: "es", CU: "es", BO: "es", DO: "es", HN: "es", PY: "es",
  SV: "es", NI: "es", CR: "es", PA: "es", UY: "es",
  BR: "pt", PT: "pt", AO: "pt", MZ: "pt", CV: "pt",
};

const SUPPORTED_LANGS = ["it", "en", "es", "pt"];
const IPAPI_URL = "https://ipapi.co/json/";
const IPAPI_TIMEOUT_MS = 1500;

const fallbackToNavigator = () => {
  const navLang =
    typeof navigator !== "undefined" && navigator.language
      ? navigator.language.toLowerCase().split("-")[0]
      : "";
  return SUPPORTED_LANGS.includes(navLang) ? navLang : "en";
};

export default async function detectUserLocale() {
  try {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), IPAPI_TIMEOUT_MS);
    const response = await fetch(IPAPI_URL, { signal: controller.signal });
    clearTimeout(timeout);

    if (response.ok) {
      const data = await response.json();
      const country = (data && data.country_code) || "";
      const mapped = COUNTRY_TO_LANG[country.toUpperCase()];
      if (mapped) return mapped;
      return "en";
    }
  } catch (_err) {
    // network error, adblock, abort → fallback below
  }

  return fallbackToNavigator();
}
